import React, { useState, useContext, useEffect } from "react";
import {
  useForm,
  Controller,
  FormContext,
  useFormContext,
} from "react-hook-form";
import { Grid, Box, Paper } from "@material-ui/core";
import useStyles from "../../../../../themes/makeStyles";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import PathsandTitle from "../../../../../constants/pathsAndTitle";
import MainHeading from "../../../../../components/MainHeading";
import { useHistory } from "react-router-dom";
import TextField from "../../../../../components/TextField";
import DateComponent from "../../../../../components/DateComponent";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import FormValidationErrorMessage from "../../../../../components/FormValidationErrorMessage";
import Autocomplete from "../../../../../components/AutoComplete";
import GlobalContext from "../../../../../common/contexts/GlobalContext";
import { default as CommonMethods } from "../../../../../common/commonMethods";
import Notifications from "../../../../../components/Notifications";
import LabelConstantsData from "../../../../../constants/LabelConstantsData";
import LobConstants from "../../../../../constants/LobConstants";
import { default as Apiservices } from "../../../../../common";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import SimpleBackdrop from "../../../../../components/Backdrop";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import MultiSelectAutocomplete from "../../../../../components/MultiSelectAutoCompleteController";
import DateRangePicker from "../../../../../components/DateRangePicker";
import * as XLSX from "xlsx/xlsx.mjs";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));
const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
    whiteSpace: "nowrap",
    td: {},
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "80vh",
    minHeight: "100px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      /* Track */
      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },
      /* Handle */
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
      },
      /* Handle on hover */
      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function RevenueReport() {
  var classesTwo = useStyles();
  const classes = useStyles2();
  const history = useHistory();
  const methods = useForm();
  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
    triggerValidation,
  } = methods;

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  const [expandedPanel, setExpandedPanel] = React.useState({
    panel1: true,
    panel2: true,
    panel3: true,
    panel4: true,
  });

  const handleToggle = () => {
    return true;
  };
  const handleClose = () => {
    return true;
  };

  const handleAccordionChange =
    (panel, expandedPanel) => (event, isExpanded) => {
      let expansionPanelList = {};
      expansionPanelList = expandedPanel;

      expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
      setExpandedPanel({
        panel1:
          panel === "panel1"
            ? expansionPanelList[panel]
            : expansionPanelList["panel1"],
        panel2:
          panel === "panel2"
            ? expansionPanelList[panel]
            : expansionPanelList["panel2"],
        panel3:
          panel === "panel3"
            ? expansionPanelList[panel]
            : expansionPanelList["panel3"],
        panel4:
          panel === "panel4"
            ? expansionPanelList[panel]
            : expansionPanelList["panel4"],
      });
    };

  const [displayBackDrop, setDisplayBackDrop] = useState(false);
  const [rakename, setRakename] = useState([]);
  const [fy, setfy] = useState([]);
  const [reportres, setReportRes] = useState([]);
  const [Div, setDiv] = useState();
  const [downloadData, setDownloadData] = useState([]);
  const [difAVG, setDifAVG] = useState();
  const [dateRange, setDateRange] = useState([]);
  const [rangePic, setrangePic] = useState(false);
  const [dateRangeText, setDateRangeText] = useState("");

  const handleDiv = (e, flag) => {
    if (e == "Monthly") {
      setrangePic(true);
      setDiv(12);
      setDateRange([
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ]);
    } else if (e == "Quartly") {
      setDiv(4);
      setrangePic(true);
      setDateRange(["Q1", "Q2", "Q3", "Q4"]);
    } else if (e == "Half Yearly") {
      setDiv(6);
      setrangePic(true);
      setDateRange(["H1", "H2"]);
    } else if (e == "Yearly") {
      setDiv(1);
      setrangePic(false);
      setDateRange([]);
    } else {
      setrangePic(false);
      setDateRange([]);
      setDiv(1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      generateFinancialYearsRange();
      let postData = {
        flag: "1",
        filter: null,
      };
      setDisplayBackDrop(true);
      const listsResponse = await Apiservices.getRevenueReportList(postData);
      let rake_data = listsResponse;
      let list = rake_data.map((row) => {
        return { label: row.rake_no, value: row.rake_no_value };
      });
      setRakename(list);
      setDisplayBackDrop(false);
    };
    fetchData();
  }, []);

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    if (month >= 3) {
      return `${year}-${year + 1}`;
    } else {
      return `${year - 1}-${year}`;
    }
  };

  const generateFinancialYearsRange = () => {
    let currentFY = getCurrentFinancialYear();
    const [startYear, endYear] = currentFY.split("-").map(Number);
    const range = [];
    for (let i = -2; i <= 2; i++) {
      const start = startYear + i;
      const end = endYear + i;
      range.push(`${start} - ${end}`);
    }
    setfy(range);
  };

  const HandleData = async () => {
    let validateform = await methods.triggerValidation();
    if (validateform) {
      let rake = methods.getValues("rake");
      let postData = {
        flag: "2",
        filter: {
          rake_no_value: handMultiSelect(rake, 1),
          rake_no: handMultiSelect(rake, 2),
          type: methods.getValues("type"),
          range: methods.getValues("range"),
          div: Div,
        },
      };

      setDisplayBackDrop(true);
      const listsResponse = await Apiservices.getRevenueReport(postData);
      setDateRangeText(listsResponse.message);
      let table_data = listsResponse.Records;
      // console.log(table_data);
      setReportRes(table_data);
      setDownloadData(table_data);
      setDisplayBackDrop(false);
      handleAvg(table_data);
    } else {
      setNotify({
        isOpen: true,
        message: `${LabelConstantsData.NOTIFICATION_INFO.CHECK_ALL_MANDATORY_FIELDS}`,
        type: "error",
        timing: 2000,
      });
    }
  };

  const handleAvg = (Data) => {
    let num = 0;
    let AVG = Data.map((row) => {
      num = num + Number(row.difference);
    });
    num = num / Data.length;
    setDifAVG(num);
    methods.setValue("div_avg", num);
  };

  const handMultiSelect = (data, flag) => {
    if (flag == 1) {
      let submitteddata = data;
      let temp = [];
      submitteddata.map((row) => {
        temp.push(row.value);
      });
      let SelectedData = JSON.stringify(temp);
      SelectedData = SelectedData.replaceAll('","', ",");
      SelectedData = SelectedData.replaceAll('"', "");
      SelectedData = SelectedData.replaceAll("[", "");
      SelectedData = SelectedData.replaceAll("]", "");
      return SelectedData;
    } else {
      let submitteddata = data;
      let temp = [];
      submitteddata.map((row) => {
        temp.push(row.label);
      });
      let SelectedData = JSON.stringify(temp);
      SelectedData = SelectedData.replaceAll('","', ",");
      SelectedData = SelectedData.replaceAll('"', "");
      SelectedData = SelectedData.replaceAll("[", "");
      SelectedData = SelectedData.replaceAll("]", "");
      return SelectedData;
    }
  };

  const ExcelDownload = async () => {
    if (downloadData.length == 0) {
      setNotify({
        isOpen: true,
        message: `No Data to export`,
        type: "warning",
        timing: 3000,
      });
    } else {
      setNotify({
        isOpen: true,
        message: `Downloading..`,
        type: "success",
        timing: 3000,
      });

      let excel_dwn = downloadData.map((row, index) => {
        return {
          "Sl No": index + 1,
          "Origin ": String(row.origin_code),
          "Destination ": String(row.destination_code),
          "Operating Days": String(row.operating_days),
          "Threshold ": String(row.anual_threshold),
          "WO Fees": String(row.wo_fees),
          "WO TAT": String(row.wo_tat),
          "Actual TAT": String(row.c_actual_tat),
          "Revised Fee": String(row.c_revised_fee),
          "Revenu ": String(row.revenue),
          "Defference ": String(row.difference),
          "Avarage ": difAVG,
        };
      });
      let wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(excel_dwn);
      XLSX.utils.book_append_sheet(wb, ws, "sheet1");
      XLSX.writeFile(wb, "Revenue Report.xlsx");
    }
  };

  return (
    <div>
      <FormContext {...methods}>
        <form Validate id="clearance">
          <React.Fragment>
            <Box py={1}>
              <Paper elevation={0}>
                <Box px={4} py={2}>
                  <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm>
                      <Box>
                        <h3 className={classes.secondHeading}>
                          Revenue Report
                        </h3>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box px={4} py={2}>
                  <Box pt={1}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <MultiSelectAutocomplete
                          name={`rake`}
                          Values={rakename}
                          rules={{ required: true }}
                          error={methods.errors.rake}
                          label="Select Rake"
                          required
                        />
                        {methods.errors.rake && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="Rake"
                            name="rake"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`type`}
                          Values={[
                            "Monthly",
                            "Quartly",
                            "Yearly",
                            "Half Yearly",
                          ]}
                          getValueChanged={(e) => handleDiv(e, false)}
                          rules={{ required: true }}
                          error={methods.errors.type}
                          label="Report Type"
                          required
                        />
                        {methods.errors.type && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="Report Type"
                            name="type"
                          />
                        )}
                      </Grid>
                      {rangePic && (
                        <Grid item xs={12} sm={6} md={6} lg={3}>
                          <Autocomplete
                            name={`range`}
                            Values={dateRange}
                            rules={{ required: true }}
                            error={methods.errors.range}
                            label="Select Range"
                            required
                          />
                          {methods.errors.range && (
                            <FormValidationErrorMessage
                              errors={methods.errors}
                              errorMessagePrefix="Range"
                              name="range"
                            />
                          )}
                        </Grid>
                      )}

                      <Grid item>
                        <Button
                          onClick={HandleData}
                          color="primary"
                          variant="contained"
                          // className="btnMinWidthSearch"
                        >
                          Generate
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </Box>

            <Box py={1}>
              <Paper elevation={0}>
                <Accordion
                  expanded={expandedPanel["panel3"] === true}
                  onChange={handleAccordionChange("panel3", expandedPanel)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography className={classes.secondHeading}>
                      Report Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box width="100%">
                      <Grid container spacing={2} justify="flex-end">
                        <Grid item>
                          {dateRangeText !== "" ? (
                            <>
                              <b>Date Range - {dateRangeText}</b>
                            </>
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid item>
                          <TextField
                            name="div_avg"
                            fullWidth
                            label="AVG"
                            type="number"
                            control={control}
                            defaultValue={0}
                            disabled={true}
                          />
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            className={clsx(classes.subTextButton)}
                            type="button"
                            startIcon={<CloudDownloadIcon />}
                            onClick={ExcelDownload}
                          >
                            Export to Excel
                          </Button>
                        </Grid>
                      </Grid>
                      <TableContainer className={"freezeTable2"}>
                        <Table aria-label="simple table" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Origin</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Destination</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Operating Days</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Threshold</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>WO Fees </b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>WO TAT</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Actual TAT</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Revised Fee</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Revenu for Current Period</b>
                              </StyledTableCell>
                              <StyledTableCell style={{ minWidth: 100 }}>
                                <b>Defference</b>
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {reportres?.map((row, index) => (
                              <TableRow>
                                <TableCell>
                                  {row.origin_code ? (
                                    <b>{row.origin_code}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.origin_code ? (
                                    <b>{row.destination_code}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.operating_days ? (
                                    <b>{row.operating_days}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.anual_threshold ? (
                                    <b>{row.anual_threshold}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.wo_fees ? (
                                    <b>{row.wo_fees}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.wo_tat ? <b>{row.wo_tat}</b> : <b>-</b>}
                                </TableCell>
                                <TableCell>
                                  {row.c_actual_tat ? (
                                    <b>{row.c_actual_tat}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.c_revised_fee ? (
                                    <b>{row.c_revised_fee}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.revenue ? (
                                    <b>{row.revenue}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                                <TableCell>
                                  {row.difference != null ? (
                                    <b>{row.difference}</b>
                                  ) : (
                                    <b>-</b>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Paper>
            </Box>
          </React.Fragment>
        </form>
        {displayBackDrop && (
          <SimpleBackdrop
            handleToggle={handleToggle}
            handleClose={handleClose}
          />
        )}
        <Notifications notify={notify} setNotify={setNotify} />
      </FormContext>
    </div>
  );
}
